import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  GET,
  Params,
  Query,
} from '@app/core/api';
import type {BootstrapResult} from '@app/core/interfaces/bootstrap-result.interface';
import type {CityResult} from '@app/core/interfaces/city-result.interface';
import type {PrefixResult} from '@app/core/interfaces/prefix-result.interface';
import type {ProviderSendRestrictionResult} from '@app/core/interfaces/provider-send-restriction-result.interface';
import type {ProvinceResult} from '@app/core/interfaces/province-result.interface';
import {AccessSectionEnum} from '@shared/enums/access-section.enum';

@ApiController('api/app')
@Injectable({
  providedIn: 'root',
})
export class AppApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET('/base-data/prefix')
  getPrefix(): Observable<ApiResponse<PrefixResult>> {
    return {} as Observable<ApiResponse<PrefixResult>>;
  }

  @GET('/bootstrapper')
  getBootstrapper(): Observable<ApiResponse<BootstrapResult>> {
    return {} as Observable<ApiResponse<BootstrapResult>>;
  }

  @GET('/setting/province')
  getProvinces(): Observable<ApiResponse<ProvinceResult[]>> {
    return {} as Observable<ApiResponse<ProvinceResult[]>>;
  }

  @GET('/setting/province/:provinceId/city')
  getCities(@Params('provinceId') provinceId: number): Observable<ApiResponse<CityResult[]>> {
    return {} as Observable<ApiResponse<CityResult[]>>;
  }

  @GET('/send/cancellation-keyword')
  getCancellationKeyword(@Query() query: Record<string, unknown>): Observable<ApiResponse<string>> {
    return {} as Observable<ApiResponse<string>>;
  }

  @GET('/provider/send/restriction')
  getProviderSendRestriction(): Observable<ApiResponse<ProviderSendRestrictionResult>> {
    return {} as Observable<ApiResponse<ProviderSendRestrictionResult>>;
  }

  @GET('/access/limitation/:accessSection')
  checkAccessLimitation(
    @Params('accessSection') accessSection: AccessSectionEnum,
    @Query('count') count?: number,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @GET('/setting/utc-now')
  getUtcNow(): Observable<number> {
    return {} as Observable<number>;
  }
}
